import * as actionTypes from '../../../modules/actions'

export const REQUEST_FORM = 'REQUEST_FORM'
export const CHANGE_PASSWORD_FORM = 'CHANGE_PASSWORD_FORM'

const initialState = {
  mode: REQUEST_FORM,
  email: '',
  insurance_policy_no: '',
  kana_name: '',
  birth_date: '',
  password: '',
  passwordConfirm: '',
  isSubmitted: false,
  errors: [],
}

export default (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.RESET_PASSWORD_RESET_STATE:
      return initialState
    case actionTypes.RESET_PASSWORD_UPDATE_STATE:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/resetPassword/modules/reducer.js